/** 调用消耗 / 后台列表：把技术 model_id 转成可读名称（含 Seedream Lite / Pro）。 */

const SEEDREAM_LITE_DEPLOY_IDS = new Set(['doubao-seedream-5-0-260128'])

function normalizeSeedreamKey(modelId = '') {
  return String(modelId || '')
    .trim()
    .toLowerCase()
    .replace(/-\d{6,8}$/, '')
    .replace(/(seedream-)(\d+)-(\d+)(-(?:lite|pro))?\b/i, '$1$2.$3$4')
}

export function seedreamVariant(modelId = '') {
  const raw = String(modelId || '').trim()
  if (!raw || !/seedream/i.test(raw)) return null
  const key = normalizeSeedreamKey(raw)
  if (/-pro\b/i.test(key) || /\.pro\b/i.test(key)) return 'pro'
  if (/-lite\b/i.test(key) || /\.lite\b/i.test(key)) return 'lite'
  if (SEEDREAM_LITE_DEPLOY_IDS.has(raw.toLowerCase())) return 'lite'
  // 5.0 无 pro 后缀的方舟部署默认为 Lite
  if (/seedream-5[.-]0\b/i.test(key) && !/pro/i.test(key)) return 'lite'
  return null
}

export function formatModelDisplayName(modelId = '', extra = null) {
  const fromExtra = extra?.modelDisplayName || extra?.pricing?.modelDisplayName
  if (fromExtra) return String(fromExtra)

  const raw = String(modelId || '').trim()
  if (!raw) return '—'

  const variant = seedreamVariant(raw)
  if (variant === 'pro') return 'Seedream 5.0 Pro'
  if (variant === 'lite') return 'Seedream 5.0 Lite'

  const low = raw.toLowerCase()
  if (low.includes('qwen-vl')) return low.includes('plus') ? '千问 VL Plus' : '千问 VL'
  if (low.startsWith('doubao-seedance-')) {
    return `Seedance ${raw.split('doubao-seedance-', 1)[1].replace(/-/g, ' ')}`
  }
  return raw
}

export function seedreamVariantTag(modelId = '', extra = null) {
  const variant = extra?.seedreamVariant || seedreamVariant(modelId)
  if (variant === 'pro') return 'Pro'
  if (variant === 'lite') return 'Lite'
  return ''
}
